'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _lodash = require('lodash');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var AccessoryContainerController = function () {
  function AccessoryContainerController(authService, enums, $stateParams, lookupService, loadingService, accessoryManagementService) {
    "ngInject";

    (0, _classCallCheck3.default)(this, AccessoryContainerController);
    this.$stateParams = $stateParams;
    this.lookupService = lookupService;
    this.loadingService = loadingService;
    this.accessoryManagementService = accessoryManagementService;

    this.accessoryLookups = [];
    this.initializeAccessories();

    this.state = '';
    this.resetNotification();
  }

  (0, _createClass3.default)(AccessoryContainerController, [{
    key: 'resetNotification',
    value: function resetNotification() {
      this.notification = {
        type: '',
        msg: ''
      };
    }
  }, {
    key: 'initializeAccessories',
    value: function initializeAccessories() {
      var ctrl = this;

      ctrl.loadingService.showLoading('accessoryList', 'Loading Accessories ...');

      ctrl.lookupService.lookupAccessoryLookups(ctrl.$stateParams.locationId, true).then(function (accessoryLookups) {
        ctrl.accessoryLookups = accessoryLookups;
      }).finally(function () {
        ctrl.loadingService.hideLoading('accessoryList');
      });
    }
  }, {
    key: 'addAccessory',
    value: function addAccessory() {
      var ctrl = this;

      ctrl.resetNotification();

      if (!ctrl.tempName || ctrl.tempName.length < 3 || ctrl.tempName.length > 40) {
        ctrl.notification = {
          type: 'error',
          msg: 'Name is required field and must be between 3 and 40 characters'
        };

        return;
      } else if ((0, _lodash.find)(ctrl.accessoryLookups, function (a) {
        return a.name === ctrl.tempName;
      })) {
        ctrl.notification = {
          type: 'error',
          msg: ctrl.tempName + ' is already added to the list'
        };

        return;
      } else {
        ctrl.accessoryLookups.push({ name: ctrl.tempName });
        ctrl.tempName = '';
      }
    }
  }, {
    key: 'removeAccessory',
    value: function removeAccessory(accessory) {
      this.accessoryLookups = (0, _lodash.without)(this.accessoryLookups, accessory);
    }
  }, {
    key: 'saveChanges',
    value: function saveChanges() {
      var _this = this;

      var ctrl = this;

      var accessoryList = ctrl.accessoryLookups.map(function (a) {
        return a.name;
      });

      ctrl.loadingService.showLoading('accessoryList', 'Updating Accessories ...');

      ctrl.accessoryManagementService.updateAccessories(ctrl.$stateParams.locationId, accessoryList).then(function (response) {
        _this.notification = {
          type: 'success',
          msg: 'Accessories updated successfully'
        };
      }).catch(function (err) {
        _this.notification = {
          type: 'error',
          msg: 'An error occurred while updating accessories'
        };
      }).finally(function () {
        ctrl.loadingService.hideLoading('accessoryList');
      });
    }
  }]);
  return AccessoryContainerController;
}();

exports.default = AccessoryContainerController;


// WEBPACK FOOTER //
// ./client/app/components/accessoryManagement/accessoryContainer/accessoryContainer.controller.js